<template>
  <div class="customHomeButtonContainer">
    <button
      class="customHomeButton"
      @click="showCustomHome"
      :class="{ 'customHomeButton-isActive': active }"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="28px"
        viewBox="0 -960 960 960"
        width="28px"
        fill="currentColor"
      >
        <path d="M160-120v-480l320-240 320 240v480H560v-280H400v280H160Z" />
      </svg>
      <span style="margin-top: 5px">Home</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "CustomHomeButton",
  props: {
    active: Boolean
  },
  methods: {
    /**
     * shows custom home products / promos
     */
    showCustomHome() {
      this.$emit("onShowCustomHome");
    }
  }
};
</script>

<style lang="scss" scoped>
.customHomeButtonContainer {
  height: 80px;
}
.customHomeButton {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: var(
    --component_menu_CustomHomeButton_customHomeButton_background
  );
  border: var(--component_menu_CustomHomeButton_customHomeButton_border);
  color: var(--component_menu_CustomHomeButton_customHomeButton_color);
  font-family: var(
    --component_menu_CustomHomeButton_customHomeButton_font-family
  );
  font-size: var(--component_menu_CustomHomeButton_customHomeButton_font-size);
  height: 50px;
  margin: 25px 0 0 30px;
  text-align: left;
  width: 200px;
  &-isActive {
    background: var(
      --component_menu_CustomHomeButton_customHomeButton-isActive_background
    );
    border: var(
      --component_menu_CustomHomeButton_customHomeButton-isActive_border
    );
    color: var(
      --component_menu_CustomHomeButton_customHomeButton-isActive_color
    );
  }
}
</style>
